import { gql } from '@apollo/client';

export default gql`
  query FoldersQuery($condition: FolderCondition!) {
    folders: allFolders(condition: $condition) {
      nodes {
        id
        name
        parentId
      }
    }
  }
`;
